import React, { useEffect, useState } from 'react';
import './DbSettings.css'
import { Back } from '../../../../../../../components/back/Back';


const DBSettings = ({serviceName, setDb, back, next, dbSetting}) => {

    const [includeDb, setIncludeDb] = useState(Object.keys(dbSetting).length > 0 ? true : false);
    const [settings, setSetting] = useState(Object.keys(dbSetting).length > 0 ? dbSetting : {
        db_type: "KubernetesDeployment",
        db_flavor: "mysql",
        root_password: "",
        include_autoScale: false,
        max_replicas: 1,
        min_replicas: 1,
        include_service: true,
        include_pv: true,
        pv_storage_class: "local-path",
        pv_storage_path: `/data/dbs-local-storage/${serviceName}`,
        pv_mount_path: "/var/lib/mysql",
        storage_amount: "1Gi"
    })

    const flavors = [
        {
            name: "mysql",
            mountPath: "/var/lib/mysql"
        },
        {
            name: "postgres",
            mountPath: "/var/lib/postgresql"
        },
        {
            name: "redis",
            mountPath: ""
        }
    ]


    return (
        <div className='db-settings'>
              <Back back={()=>{if (includeDb) {setDb(settings)} else {setDb({})};back()}}/>
            <div className='include-db'>
                <input checked={includeDb} value={includeDb} onChange={() => setIncludeDb(!includeDb)} type='checkbox'/>
                <label>Include DB</label>
            </div>
            {includeDb && 
                <div className='main-data'>
                    <select onChange={(e)=>setSetting({...settings, db_flavor: e.target.value, pv_mount_path: flavors.find(flavor => flavor.name === e.target.value).mountPath})}>
                        {flavors.map(flavor=>{
                            return <option selected={settings.db_flavor === flavor.name} value={flavor.name}>{flavor.name}</option>})}
                    </select>
                    <div>
                        <label>db location</label>
                        <select onChange={(type)=>setSetting({...settings, db_type: type.target.value})}>
                            <option selected={settings.db_type === "KubernetesDeployment"} value="KubernetesDeployment">k8s deployment</option>
                            {/* <option selected={settings.db_type === "clouddb"} value="clouddb">db as cloud sevice</option>
                            <option selected={settings.db_type === "external"} value="external">external db</option> */}
                        </select>
                    </div>
                    { (settings.db_flavor === "mysql" || settings.db_flavor === "postgres") && <div>
                        <label>db credentials</label>
                        {/* <div>
                            <label>username:</label>
                            <input value={settings[settings.db_type].username} type='text' onChange={(e)=>{setSetting({...settings, [settings.db_type]: {...settings[settings.db_type], username: e.target.value}})}}/>
                        </div> */}
                        <div>
                            <label>root password:</label>
                            <input value={settings.root_password} type='text' className='maskedInput' onChange={e=>setSetting({...settings, root_password: e.target.value})}/>
                        </div>
                    </div>}
                </div>}
                <button className='next-button' onClick={()=>{if (includeDb) {setDb(settings)} else {setDb({})};next()}}>next</button>
        </div>
    );
};

export default DBSettings;